import { createApp } from 'vue';
import { instalarCapturaVue } from '../src/services/monitoramento';

window.createVueApp = (...args) => instalarCapturaVue(createApp(...args));
